import LanguageSelect from './styled';

export default LanguageSelect;
